//-----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------

// import React, { useState, useEffect, useCallback } from 'react';
// import { utils, write } from 'xlsx';
// import { Buffer } from 'buffer';
// import axios from 'axios'
// import CountUp from 'react-countup';
// import Login from './Components/Login';
// import Logout from './Components/Logout';
// import './App.css';
// import useUploadSuppression from './Components/suppression';
// import { applySuppression } from './Components/suppression';
// import useUploadTAL from './Components/TAL';
// import useUploadMD5Suppression from './Components/MD5 Suppression';

// import Navbar from './Components/Navbar';
// import JobLevel from './Components/Joblevel';
// import StateNames from './Components/StateNames';
// import Keyword from './Components/Keyword';
// import CityNames from './Components/CityNames';
// import Geo from './Components/Geo';
// import JobFunction from './Components/JobFunction';
// import EmployeeSize from './Components/EmployeeSize';
// import Industry from './Components/Industry';
// import SubIndustry from './Components/SubIndustry';
// import SIC from './Components/Sic';
// import NAICS from './Components/Naics';
// import Revenue from './Components/Revenue';
// import SKU from './Components/SKUCode'
// import Client from './Components/EndClient';
// import DateRangeFilter from './Components/DateRangeFilter';
// import ProgressBar from 'react-progressbar';
// import debounce from 'lodash.debounce';
// import XLSX from 'xlsx';
// import LZString from 'lz-string';
// import { useBeforeunload } from 'react-beforeunload';
// import Loader from 'react-loader-spinner';
// import PuffLoader from 'react-loader-spinner';
// import { Puff } from 'react-loader-spinner';




// const App = () => {
//   const [data, setData] = useState([]);
//   const [selectedKeyword, setSelectedKeyword] = useState([]);
//   const [jobLevelOptions, setJobLevelOptions] = useState([]);
//   const [selectedStates, setSelectedStates] = useState([]);
//   const [selectedCities, setSelectedCities] = useState([]);
//   const [selectedGeo, setSelectedGeo] = useState([]);
//   const [selectedJobFunction, setSelectedJobFunction] = useState([]);
//   const [selectedEmployeeSize, setSelectedEmployeeSize] = useState([]);
//   const [selectedIndustry, setSelectedIndustry] = useState([]);
//   const [selectedSubIndustry, setSelectedSubIndustry] = useState([]);
//   const [filteredData, setFilteredData] = useState([]);
//   const [selectedSicCode, setSelectedSicCode] = useState([]);
//   const [selectedNaicsCode, setSelectedNaicsCode] = useState([]);
//   const [selectedRevenue, setSelectedRevenue] = useState([]); 
//   const [selectedDateRange, setSelectedDateRange] = useState({ from: '', to: '' });
//   const [selectedSKU, setSelectedSKU] = useState([]);
//   const [selectedClient, setSelectedClient] = useState([]);
//   const [resetFilters, setResetFilters] = useState(false);
//   const [exporting, setExporting] = useState(false);
//   const [error, setError] = useState(null); 
//   const [isSubmitting, setIsSubmitting] = useState(false);  
//   const [shouldSubmitFilters, setShouldSubmitFilters] = useState(false);
//   const [isLoading, setIsLoading] = useState(false);

//   const [ setFile] = useState(null);
//   // const { file: suppressionFile, handleFileChange: handleSuppressionFileChange, applySuppression } = useUploadSuppression();
//   const [suppressionFile, setSuppressionFile] = useState(null);
//   const { file, handleFileChange, handleApplySuppression, applied, applySuppression, suppressionData } = useUploadSuppression(filteredData, setFilteredData);

//   const { talFile, handleTALFileChange, talData, applyTAL, setTalFile } = useUploadTAL(filteredData, setFilteredData);

//   const { file: md5File, handleFileChange: handleMD5FileChange, applyMD5Suppression, md5Data } = useUploadMD5Suppression(filteredData, setFilteredData);

//   // const { file: talFile, handleFileChange: handleTALFileChange, applyTAL } = useUploadTAL();

//   const [currentUserEmail, setCurrentUserEmail] = useState(''); // State to store the logged-in user's email
//   const [isLoggedIn, setIsLoggedIn] = useState(false); // new state to track login status
//   const [username, setUsername] = useState(''); // new state to store username
//   const [password, setPassword] = useState(''); // new state to store password
//   const [loginError, setLoginError] = useState('');
//   const [userRole, setUserRole] = useState('');

//   const [totalDataCount, setTotalDataCount] = useState(0);
//   const [count, setCount] = useState(0);
//   const [previousCount, setPreviousCount] = useState(0);
//   const [exportDisabled, setExportDisabled] = useState(false); // new state to track export button disable
//   const [exportMessage, setExportMessage] = useState(''); // new state to track export message



// useEffect(() => {
//   const handleBeforeUnload = (event) => {
//     const message = 'Do you really want to refresh? NOTE: Refreshing the app again will lead to loading of data again which might take few minutes. Consider resetting the filters.';
//     (event || window.event).returnValue = message;
//     return message;
//   };

//   window.addEventListener('beforeunload', handleBeforeUnload);

//   return () => {
//     window.removeEventListener('beforeunload', handleBeforeUnload);
//   };
// }, []);


//   const filterData = useCallback((data) => {
//     let filteredData = data;

//     if (selectedKeyword.length > 0) {
//       filteredData = filteredData.filter((item) => {
//         return selectedKeyword.some((option) => item.OriginalJobTitle !== null && item.OriginalJobTitle.includes(option.value));
//       });
//     }

//     if (jobLevelOptions.length > 0) {
//       filteredData = filteredData.filter((item) => {
//         return jobLevelOptions.some((option) => item.JobLevel !== null && item.JobLevel.includes(option.value));
//       });
//     }

//     if (selectedJobFunction.length > 0) {
//       filteredData = filteredData.filter((item) => {
//         return selectedJobFunction.some((option) => item.JobFunction !== null && item.JobFunction.includes(option.value));
//       });
//     }

//     if (selectedGeo.length > 0) {
//       filteredData = filteredData.filter((item) => {
//         return selectedGeo.some((option) => item.Country !== null && item.Country.includes(option.value));
//       });
//     }

//     if (selectedStates.length > 0) {
//       filteredData = filteredData.filter((item) => {
//         return selectedStates.some((option) => item.State !== null && item.State.includes(option.value));
//       });
//     }

//     if (selectedCities.length > 0) {
//       filteredData = filteredData.filter((item) => {
//         return selectedCities.some((option) => item.City !== null && item.City.includes(option.value));
//       });
//     }

//     if (selectedIndustry.length > 0) {
//       filteredData = filteredData.filter((item) => {
//         return selectedIndustry.some((option) => item.OriginalIndustry !== null && item.OriginalIndustry.includes(option.value));
//       });
//     }

//     if (selectedSubIndustry.length > 0) {
//       filteredData = filteredData.filter((item) => {
//         return selectedSubIndustry.some((option) => item.SubIndustry !== null && item.SubIndustry.includes(option.value));
//       });
//     }

//     if (selectedSicCode.length > 0) {
//       filteredData = filteredData.filter((item) => {
//         return selectedSicCode.some((option) => item.SIC !== null && item.SIC.includes(option.value));
//       });
//     }

//     if (selectedNaicsCode.length > 0) {
//       filteredData = filteredData.filter((item) => {
//         return selectedNaicsCode.some((option) => item.NAICS !== null && item.NAICS.includes(option.value));
//       });
//     }

//     if (selectedDateRange.length > 0) {
//       filteredData = selectedDateRange;
//     }

//     if (selectedEmployeeSize.length > 0) {
//       filteredData = selectedEmployeeSize.reduce((acc, curr) => {
//         const [minValue, maxValue] = curr.value.replace(/,/g, '').split('-').map(Number);
//         return acc.concat(filteredData.filter((item) => {
//           const empSize = parseInt(item.EmployeeSize.replace(/,/g, ''));
//           return empSize >= minValue && empSize <= maxValue;
//         }));
//       }, []);
//     }

//     if (selectedRevenue.length > 0) {
//       filteredData = selectedRevenue.flatMap((curr) => {
//         const [minValue, maxValue] = curr.value.replace(/,/g, '').split('-').map(Number);
//         return data.filter((item) => {
//           if (item.Revenue !== null && item.Revenue !== undefined) {
//             const revenueSizeString = item.Revenue;
//             const revenueSize = parseFloat(revenueSizeString.replace('$', '').replace(' Million', 'e6').replace(' Billion', 'e9'));
//             return revenueSize >= minValue && revenueSize <= maxValue;
//           } else {
//             return false; // or some other logic to handle this case
//           }
//         });
//       });
//     }

//     if (selectedSKU.length > 0) {
//       filteredData = filteredData.filter((item) => {
//         return selectedSKU.some((option) => item.SKUCode !== null && item.SKUCode.includes(option.value));
//       });
//     }

//     if (selectedClient.length > 0) {
//       filteredData = filteredData.filter((item) => {
//         return selectedClient.some((option) => item.EndClient !== null && item.EndClient.includes(option.value));
//       });
//     }

//     if (md5File) {
//       filteredData = applyMD5Suppression(filteredData); // Apply MD5 suppression
//     }


//     if (suppressionFile) {
//       filteredData = applySuppression(filteredData);
//     }

//     if (talFile) {
//       filteredData = applyTAL(filteredData);
//     }

//     if (talFile) {
//       console.log('filteredData before applyTAL:', filteredData);
//       if (talData.CompanyName.length > 0 && talData.Domain.length > 0) {
//         filteredData = applyTAL(filteredData);
//       } else {
//         console.log('talData is empty, skipping filter');
//       }
//       console.log('compressedData after applyTAL:', filteredData);
//     }

// return filteredData;
// }, [data, selectedSKU, selectedKeyword, jobLevelOptions, selectedStates, selectedCities, selectedGeo, selectedJobFunction, selectedEmployeeSize, selectedIndustry, selectedSubIndustry, selectedSicCode, selectedNaicsCode, selectedRevenue, selectedDateRange, suppressionFile, talFile, applySuppression, applyTAL, suppressionData, md5File, applyMD5Suppression]);


//     useEffect(() => {
//       const fetchTotalCount = async () => {
//         try {
//           const response = await axios.get('https://sqldatabase.ngrok.app/data');
//           // const response = await axios.get('http://localhost:3002/data');
//           console.log('Response:', response);
//           const totalRecords = response.data.totalRecords;
//           console.log('Total records:', totalRecords);
//           setTotalDataCount(totalRecords);
//         } catch (error) {
//           console.error('Error fetching total records:', error);
//         }
//       };
    
//       fetchTotalCount();
//     }, []);


    
//     // App.js    
//     useEffect(() => {
//       if (shouldSubmitFilters) {
//         setIsLoading(true); // Set isLoading to true here
//         const fetchFilteredData = async () => {
//           const filters = {
//             DateRange: selectedDateRange,
//             SKUCode: selectedSKU.map((skucode) => skucode.value),
//             EndClient: selectedClient.map((endclient) => endclient.value),
//             Keywords: selectedKeyword.map((keyword) => keyword.value),
//             JobFunction: selectedJobFunction.map((jobFunctions) => jobFunctions.value),
//             JobLevel: jobLevelOptions.map((option) => option.value),
//             Industry: selectedIndustry.map((industry) => industry.value),
//             SubIndustry: selectedSubIndustry.map((subIndustry) => subIndustry.value),
//             Geo: selectedGeo.map((geoNames) => geoNames.value),
//             StateNames: selectedStates.map((stateNames) => stateNames.value),
//             CityNames: selectedCities.map((cityNames) => cityNames.value),
//             EmployeeSize: selectedEmployeeSize.map((employeeSizeOptions) => employeeSizeOptions.value),
//             SIC: selectedSicCode.map((sic) => sic.value),
//             NAICS: selectedNaicsCode.map((naicsCode) => naicsCode.value), 
//             Revenue: selectedRevenue.map((revenueOptions) => revenueOptions.value), 
//             SuppressionData: suppressionData,
//             TALData: talData,
//             MD5Data: md5Data,
//           };
        
//           try {
//             const response = await axios.post('https://sqldatabase.ngrok.app/filteredData', filters);
//             // const response = await axios.post('http://localhost:3002/filteredData', filters);
//             const decompressedData = response.data.map((row) => {
//               Object.keys(row).forEach((key) => {
//                 row[key] = LZString.decompress(row[key]);
//               });
//               return row;
//             });
//             setFilteredData(decompressedData);
//             setCount(decompressedData.length);
//           } catch (error) {
//             console.error('Error fetching filtered data:', error);
//           } finally {
//             setIsLoading(false); // Set isLoading to false here
//           }
//         };
        
//         fetchFilteredData();
//         setShouldSubmitFilters(false);
//       }
//     }, [jobLevelOptions, selectedSKU, selectedClient , selectedIndustry, selectedSubIndustry, selectedJobFunction, selectedKeyword, selectedGeo, selectedStates, selectedCities, selectedSicCode, selectedNaicsCode, selectedRevenue, selectedEmployeeSize , suppressionData, talData, md5Data ,shouldSubmitFilters]); 

  


//   useEffect(() => {
//     if (shouldSubmitFilters) {
//       const filteredData = filterData(data);
//       setFilteredData(filteredData);
//       setCount(filteredData.length);
//       setShouldSubmitFilters(false);
//     }
//   }, [data, selectedSKU , selectedClient, selectedKeyword, selectedStates, selectedCities, selectedGeo, selectedJobFunction, selectedEmployeeSize, selectedIndustry, selectedSubIndustry, selectedSicCode, selectedNaicsCode, selectedRevenue, selectedDateRange, suppressionFile, talFile, md5Data ,shouldSubmitFilters]);



//   useEffect(() => {
//     if (count > 50000) {
//       setExportDisabled(true);
//       setExportMessage('Data cannot be exported, Please contact Admin');
//     } else {
//       setExportDisabled(false);
//       setExportMessage('');
//     }
//   }, [count]);

//   const handleDateRangeChange = (from, to) => {
//     setSelectedDateRange({ from, to });
//   };

//   const handleSKUChange = (options) => {
//     setSelectedSKU(options);
//   };

//   const handleClientChange = (options) => {
//     setSelectedClient(options);
//   };

//   const handleKeywordChange = (options) => {
//     setSelectedKeyword(options);
//   };

//   const handleJobLevelChange = (options) => {
//     setJobLevelOptions(options);
//   };

//   const handleJobFunctionChange = (options) => {
//     setSelectedJobFunction(options);
//   }; 

//   const handleGeoChange = (options) => {
//     setSelectedGeo(options);
//   };  

//   const handleStateChange = (options) => {
//     setSelectedStates(options);
//   };

//   const handleCityChange = (options) => {
//     setSelectedCities(options);
//   };

//   const handleEmployeeSizeChange = (options) => {
//     setSelectedEmployeeSize(options);
//   };

//   const handleIndustryChange = (options) => {
//     setSelectedIndustry(options);
//   };

//   const handleSubIndustryChange = (options) => {
//     setSelectedSubIndustry(options);
//   };

//   const handleSicCodeChange = (options) => {
//     setSelectedSicCode(options);
//   };

//   const handleNaicsCodeChange = (options) => {
//     setSelectedNaicsCode(options);
//   };

//   const handleRevenueChange = (options) => {
//     setSelectedRevenue(options);
//   };

//   const handleSubmit = async () => {
//     setIsLoading(true);
//     setShouldSubmitFilters(true);
//   };




//   const handleExportToExcel = () => {
//     if (!exportDisabled) {
//       const worksheet = utils.json_to_sheet(filteredData);
//       const workbook = utils.book_new();
//       utils.book_append_sheet(workbook, worksheet, 'Data');
//       const csvBuffer = write(workbook, { bookType: 'csv', type: 'buffer' });
//       const dataURI = `data:text/csv;base64,${Buffer.from(csvBuffer).toString('base64')}`;
//       const link = document.createElement('a');
//       link.href = dataURI;
//       link.download = 'Export_data.csv';
//       link.click();
//     }
//   };




//   const handleResetFiltersClick = () => {
//     setResetFilters(true);
//   };

//   const handleReset = () => {
//     setSelectedDateRange([]);
//     setSelectedSKU([]);
//     setSelectedClient([]);
//     setSelectedKeyword([]);
//     setJobLevelOptions([]);
//     setSelectedStates([]);
//     setSelectedCities([]);
//     setSelectedGeo([]);
//     setSelectedJobFunction([]);
//     setSelectedEmployeeSize([]);
//     setSelectedIndustry([]);
//     setSelectedSubIndustry([]);
//     setSelectedSicCode([]);
//     setSelectedNaicsCode([]);
//     setSelectedRevenue([]);
//     setSelectedDateRange([]);
//     setResetFilters(false); // Reset the resetFilters state variable
//     setCount(0); // Reset the count to 0
//     setSuppressionFile(null); // Reset the suppressionFile state variable
//     setTalFile(null); // Reset the talFile state variable
  
//     // Create a new file input element
//     const newTalFileInput = document.createElement('input');
//     newTalFileInput.type = 'file';
//     newTalFileInput.id = 'talFileInput';
//     newTalFileInput.name = 'talFileInput';
  
//     // Get the existing file input element
//     const talFileInput = document.getElementById('talFileInput');
  
//     // Check if the element exists before trying to access its parentNode property
//     if (talFileInput) {
//       talFileInput.parentNode.replaceChild(newTalFileInput, talFileInput);
//     } else {
//       console.log("Element with ID 'talFileInput' not found");
//     }
//   };


//   // const downloadTemplate = (templateType) => {
//   //   const templateName = templateType === 'suppression' ? 'Suppression Template.xlsm' : 'TAL Template.xlsm';
//   //   const link = document.createElement('a');
//   //   link.href = `${process.env.PUBLIC_URL}/${templateName}`;
//   //   link.download = templateName;
//   //   link.click();
//   // };


//   const downloadTemplate = (templateType) => {
//     let templateName;
  
//     // Determine the template name based on the templateType
//     if (templateType === 'suppression') {
//       templateName = 'Suppression Template.xlsm';
//     } else if (templateType === 'tal') {
//       templateName = 'TAL Template.xlsm';
//     } else if (templateType === 'md5') { // New condition for MD5 suppression template
//       templateName = 'MD5 Suppression Template.xlsx';
//     } else {
//       console.error('Invalid template type');
//       return; // Exit the function if the template type is invalid
//     }
  
//     // Create a link element to download the template
//     const link = document.createElement('a');
//     link.href = `${process.env.PUBLIC_URL}/${templateName}`;
//     link.download = templateName;
//     link.click();
//   };


  
//   const handleLogin = (username, password) => {
//     if (username === 'admin' && password === 'DemandMediaSaNaYa@2025') {
//       setIsLoggedIn(true);
//       setUserRole('admin');
//       setCurrentUserEmail('nadeem.m@demandmediabpm.com');

//     } else if (username === 'Venkat.s' && password === 'a6UsO2F7Xr5x32YX') {
//       setIsLoggedIn(true);
//       setUserRole('Venkat.s');
//       setCurrentUserEmail('venkat.s@demandmediabpm.com');

//     } else if (username === 'Majid.s' && password === 'AjUHt2O9Tv75nM2v') {
//       setIsLoggedIn(true);
//       setUserRole('Majid.s');
//       setCurrentUserEmail('majid.s@demandmediabpm.com');

//     }  else if (username === 'Arshad.b' && password === 'XB9B7xxZa0XJ1MyE') {
//       setIsLoggedIn(true);
//       setUserRole('Arshad.b');
//       setCurrentUserEmail('arshad.b@demandmediabpm.com');

//     }  else if (username === 'Subochandrabose.k' && password === 'Mlr614ViypbI4i5z') {
//       setIsLoggedIn(true);
//       setUserRole('Subochandrabose.k');
//       setCurrentUserEmail('subochandrabose.k@demandmediabpm.com');

//     } else if (username === 'Venkateshwarlu.d' && password === 'x5A815w9mkLDZoJ7') {
//       setIsLoggedIn(true);
//       setUserRole('Venkateshwarlu.d');
//       setCurrentUserEmail('venkateshwarlu.d@demandmediabpm.com');

//     } else if (username === 'Huzefa.s' && password === '4Je1G0ahUKKrXwwq') {
//       setIsLoggedIn(true);
//       setUserRole('Huzefa.s');
//       setCurrentUserEmail('huzefa.s@demandmediabpm.com');

//     }  else if (username === 'Harry.p' && password === 'ct8wgU4wLT8P1AnE') {
//       setIsLoggedIn(true);
//       setUserRole('Harry.p');

//     }  else if (username === 'Sachin.t' && password === '1wlAXo85jkTWzVrC') {
//       setIsLoggedIn(true);
//       setUserRole('Sachin.t');

//     }  else if (username === 'Shreeram.k' && password === 'MYLe38v0Th3cI7FO') {
//       setIsLoggedIn(true);
//       setUserRole('Shreeram.k');

//     }  else if (username === 'Basavraj.m' && password === '5jbbCZ15Mi2jAW23') {
//       setIsLoggedIn(true);
//       setUserRole('Basavraj.m');

//     }  else {
//       setLoginError('Incorrect ID or Password. Please contact admin');
//     }
//   };



//   const handleExportToEmail = async () => {
//     if (!exportDisabled && currentUserEmail) {
//         try {
//             // Convert filtered data to CSV format
//             const worksheet = utils.json_to_sheet(filteredData, {
//               cellDates: true, // This option ensures that date cells are treated as dates
//             });
//             const workbook = utils.book_new();
//             utils.book_append_sheet(workbook, worksheet, 'Filtered Data');

//             // Write the workbook to a CSV string
//             const csvBuffer = write(workbook, { bookType: 'csv', type: 'buffer' });

//             // Create a FormData object to send the file
//             const formData = new FormData();
//             const file = new Blob([csvBuffer], { type: 'text/csv' });
//             formData.append('file', file, 'FilteredData.csv'); // Ensure the key matches
//             formData.append('email', currentUserEmail); // Ensure email is included

//             // Include the count in the subject
//             const subject = `Exported Data - Count: ${count}`; // Assuming 'count' is the count of filteredData
//             formData.append('subject', subject); // Add subject to the form data

//             // Send the email with the CSV file
//             const response = await axios.post('https://sqldatabase.ngrok.app/sendExportedData', formData, {
//                 headers: {
//                     'Content-Type': 'multipart/form-data' // Important for file uploads
//                 }
//             });

//             alert(response.data.message);
//         } catch (error) {
//             console.error('Error sending email:', error);
//             alert('Failed to send email. Please try again.');
//         }
//     } else {
//         alert('Export is disabled or user is not logged in.');
//     }
// };


//   const handleLogout = () => {
//     setIsLoggedIn(false);
//     setCount(0); // Reset the count to 0 when logging out
//   };



//   return (
//     <div>
//       {isLoggedIn ? (
//         <div>
//           {isLoading ? (
//               <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(255, 255, 255, 0.7)', zIndex: 1000, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
//               <Puff color="#00BFFF" height={100} width={100} />
//             </div>
//           ) : (
//             <div>
//               {/* <Navbar title="CM360" logout={<Logout handleLogout={handleLogout} />} /> */}
//               <Navbar title="CM360" logout={<Logout handleLogout={handleLogout} />} username={username} />
//               <div className='top-container'>
//                 <div className='columns-container' style={{
//                   display: 'grid',
//                   gridTemplateColumns: '1fr 1fr',
//                   justifyContent: 'center',
//                   alignItems: 'center',
//                   textAlign: 'center',
//                   maxWidth: 800, /* add max-width to match the width of other filters */
//                 }}>
//                   <div className='column total-records'>
//                     <p>
//                       <strong style={{ fontSize: 18, marginRight: 10, color: '#19A79C' }}>TOTAL RECORDS : </strong>
//                       <span style={{ fontSize: 24, fontWeight: 500, color: '#19A79C' }}>{totalDataCount}</span>
//                     </p>
//                   </div>
//                   <div className='column filtered-records'>
//                     <p>
//                       <strong style={{ fontSize: 18, marginRight: 10, color: '#19A79C' }}>FILTERED RECORDS :</strong>
//                       <CountUp
//                         key={count} // re-render with new value
//                         start={previousCount} // set starting value to previous count
//                         end={count}
//                         duration={2}
//                         separator=","
//                         decimals={0}
//                         prefix=""
//                         suffix=""
//                         onEnd={() => {
//                           setPreviousCount(count); // update previous count
//                           console.log("Finished counting");
//                         }}
//                         style={{ fontSize: 24, fontWeight: 500, color: count > 100000 ? 'red' : '#19A79C' }}
//                       />
//                     </p>
//                   </div>
//                 </div>
//               </div>
  
//               <div className='container'>
  
//                 <div style={{ marginBottom: 20 }}>
//                   <DateRangeFilter 
//                     data={data} 
//                     handleSelectChange={handleDateRangeChange} 
//                     />
//                 </div>

                                
//                 <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 20 }}>
//                   <div style={{ flex: 1, marginRight: 10 }}>
//                     <label style={{color:'white'}}><b>SKU Code :</b></label>
//                     <SKU 
//                       data={data} 
//                       selectedSKU={selectedSKU} 
//                       handleSelectChange={handleSKUChange} 
//                     />
//                   </div>
                                
//                   <div style={{ flex: 1 }}>
//                     <label style={{color:'white'}}><b>End Client :</b></label>
//                     <Client 
//                       data={data} 
//                       selectedClient={selectedClient} 
//                       handleSelectChange={handleClientChange} 
//                     />
//                   </div>
//                 </div>
                                
//                 <div style={{ marginBottom: 20 }}>
//                   <label style={{color:'white'}}><b>Keywords :</b></label>
//                   <Keyword 
//                     data={data} 
//                     selectedKeyword={selectedKeyword} 
//                     handleSelectChange={handleKeywordChange} 
//                   />
//                 </div>
                
//                 <div style={{ marginBottom: 20 }}>
//                   <label style={{color:'white'}}><b>Job Function :</b></label>
//                   <JobFunction 
//                     data={data} 
//                     selectedJobFunction={selectedJobFunction} 
//                     handleSelectChange={handleJobFunctionChange} 
//                   />
//                 </div>
//                 <div style={{ marginBottom: 20 }}>
//                   <label style={{color:'white'}}><b>Job Level :</b></label>
//                   <JobLevel 
//                     data={data} 
//                     jobLevelOptions={jobLevelOptions} 
//                     handleSelectChange={handleJobLevelChange} 
//                   />
//                 </div>
//                 <div style={{ marginBottom: 20 }}>
//                   <label style={{color:'white'}}><b>Industry :</b></label>
//                   <Industry 
//                     data={data} 
//                     selectedIndustry={selectedIndustry} 
//                     handleSelectChange={handleIndustryChange} 
//                   />
//                 </div>
//                 <div style={{ marginBottom: 20 }}>
//                   <label style={{color:'white'}}><b>SubIndustry :</b></label>
//                   <SubIndustry 
//                     data={data} 
//                     selectedSubIndustry={selectedSubIndustry} 
//                     handleSelectChange={handleSubIndustryChange} 
//                   />
//                 </div>
//                 <div style={{ marginBottom: 20 }}>
//                   <label style={{color:'white'}}><b>Country :</b></label>
//                   <Geo 
//                     data={data} 
//                     selectedGeo={selectedGeo} 
//                     handleSelectChange={handleGeoChange} 
//                   />
//                 </div>
//                 <div style={{ marginBottom: 20 }}>
//                   <label style={{color:'white'}}><b>States :</b></label>
//                   <StateNames 
//                     data={data} 
//                     selectedStates={selectedStates} 
//                     handleSelectChange={handleStateChange} 
//                   />
//                 </div>
//                 <div style={{ marginBottom: 20 }}>
//                   <label style={{color:'white'}}><b>City :</b></label>
//                   <CityNames 
//                     data={data} 
//                     selectedCities={selectedCities} 
//                     handleSelectChange={handleCityChange} 
//                   />
//                 </div>
//                 <div style={{ marginBottom: 20 }}>
//                   <label style={{color:'white'}}><b>Employee Size :</b></label>
//                   <EmployeeSize 
//                     data={data} 
//                     selectedEmployeeSize={selectedEmployeeSize } 
//                     handleSelectChange={handleEmployeeSizeChange} 
//                   />
//                 </div>
//                 <div style={{ marginBottom: 20 }}>
//                   <label style={{color:'white'}}><b>SIC :</b></label>
//                   <SIC
//                     data={data} 
//                     selectedSicCode={selectedSicCode} 
//                     handleSelectChange={handleSicCodeChange} 
//                   />
//                 </div>
//                 <div style={{ marginBottom: 20 }}>
//                   <label style={{color:'white'}}><b>NAICS :</b></label>
//                   <NAICS
//                     data={data} 
//                     selectedNaicsCode={selectedNaicsCode} 
//                     handleSelectChange={handleNaicsCodeChange} 
//                   />
//                 </div>   
//                 <div style={{ marginBottom: 40 }}>
//                   <label style={{color:'white'}}><b>Revenue :</b></label>
//                   <Revenue
//                     data={data} 
//                     selectedRevenue={selectedRevenue} 
//                     handleSelectChange={handleRevenueChange} 
//                   />
//                 </div>    

//             <div style={{ display: 'flex', justifyContent: 'space-between', margin: 'auto', maxWidth: '90%' }}>

//                   <div style={{ backgroundColor: '#FAF9F6', padding: 25, width: '50%', marginRight: 20, borderRadius: '20px' }}>
//                     <label style={{ color: '#1EAA9D', fontSize: 18 }}><b>Upload MD5 Suppression:</b></label>
//                     <div style={{ marginTop: 10 }}>
//                       <input type="file" onChange={(e) => handleMD5FileChange(e.target.files[0])} />
//                       {/* {suppressionFile && (
//                         <div>
//                           <p>File uploaded: {suppressionFile.name}</p>
//                           <button style={{ padding: '5px 10px', fontSize: 12 }} onClick={() => setSuppressionFile(null)}><b>Remove</b></button>
//                         </div>
//                       )} */}
//                     </div>
//                     <div style={{ marginTop: 10 }}>
//                       <button style={{ padding: '5px 10px', fontSize: 12 }} onClick={() => downloadTemplate('md5')}><b>Download MD5 Suppression Template</b></button>
//                     </div>
//                   </div>  


//                   <div style={{ backgroundColor: '#FAF9F6', padding: 25, width: '50%', marginRight: 20, borderRadius: '20px' }}>
//                     <label style={{ color: '#1EAA9D', fontSize: 18 }}><b>Upload Suppression:</b></label>
//                     <div style={{ marginTop: 10 }}>
//                       <input type="file" onChange={(e) => handleFileChange(e.target.files[0])} />
//                       {/* {suppressionFile && (
//                         <div>
//                           <p>File uploaded: {suppressionFile.name}</p>
//                           <button style={{ padding: '5px 10px', fontSize: 12 }} onClick={() => setSuppressionFile(null)}><b>Remove</b></button>
//                         </div>
//                       )} */}
//                     </div>
//                     <div style={{ marginTop: 10 }}>
//                       <button style={{ padding: '5px 10px', fontSize: 12 }} onClick={() => downloadTemplate('suppression')}><b>Download Suppression Template</b></button>
//                     </div>
//                   </div>

                      
//                   <div style={{ backgroundColor: '#FAF9F6', padding: 25, width: '50%', borderRadius: '20px'}}>
//                     <label style={{ color: '#1EAA9D', fontSize: 18 }}><b>Upload TAL:</b></label>
//                     <div style={{ marginTop: 10 }}>
//                       <input type="file" onChange={(e) => handleTALFileChange(e.target.files[0])} />
//                       {/* {talFile && (
//                         <div>
//                           <p>File uploaded: {talFile.name}</p>
//                           <button style={{ padding: '5px 10px', fontSize: 12 }} onClick={() => setTalFile(null)}><b>Remove</b></button>
//                         </div>
//                       )} */}
//                     </div>
//                     <div style={{ marginTop: 10 }}>
//                       <button style={{ padding: '5px 10px', fontSize: 12 }} onClick={() => downloadTemplate('tal')}><b>Download TAL Template</b></button>
//                     </div>
//                   </div>
//                 </div>
  
//                 <div style={{textAlign: 'center', margin: '40px'}}>
//                   <button style={{ marginRight: 10 }} onClick={() => { handleReset([]); }}>
//                     <b>Reset Filters</b>
//                   </button>
//                   <button style={{ marginRight: 10 }} onClick={handleSubmit} disabled={isSubmitting}>
//                     <b>Submit Filters</b>
//                   </button>
//                   {exportDisabled ? (
//                       <p style={{ color: 'red' }}>{exportMessage}</p>
//                     ) : (
//                       userRole === 'Basavraj.m' ||
//                       userRole === 'Shreeram.k' ||
//                       userRole === 'Sachin.t' ||
//                       userRole === 'Harry.p' ? null : (
//                         <button onClick={handleExportToEmail}>
//                           <b>Export Data</b>
//                         </button>
//                       )
//                     )}
//                 </div>
//               </div>
//             </div>
//           )}
//         </div>
//       ) : (
//         <Login handleLogin={handleLogin} loginError={loginError} />
//       )}
//     </div>
//   );
  
// };

// export default App;
//-----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------




import React, { useState, useEffect, useCallback } from 'react';
import { utils, write } from 'xlsx';
import { Buffer } from 'buffer';
import axios from 'axios'
import CountUp from 'react-countup';
import Login from './Components/Login';
import Logout from './Components/Logout';
import './App.css';
import useUploadSuppression from './Components/suppression';
import { applySuppression } from './Components/suppression';
import useUploadTAL from './Components/TAL';
import useUploadMD5Suppression from './Components/MD5 Suppression';

import Navbar from './Components/Navbar';
import JobLevel from './Components/Joblevel';
import StateNames from './Components/StateNames';
import Keyword from './Components/Keyword';
import CityNames from './Components/CityNames';
import Geo from './Components/Geo';
import JobFunction from './Components/JobFunction';
import EmployeeSize from './Components/EmployeeSize';
import Industry from './Components/Industry';
import SubIndustry from './Components/SubIndustry';
import SIC from './Components/Sic';
import NAICS from './Components/Naics';
import Revenue from './Components/Revenue';
import SKU from './Components/SKUCode'
import Client from './Components/EndClient';
import DateRangeFilter from './Components/DateRangeFilter';
import debounce from 'lodash.debounce';
import XLSX from 'xlsx';
import LZString from 'lz-string';
import { useBeforeunload } from 'react-beforeunload';
import Loader from 'react-loader-spinner';
import PuffLoader from 'react-loader-spinner';
import { Puff } from 'react-loader-spinner';




const App = () => {
  const [data, setData] = useState([]);
  const [selectedKeyword, setSelectedKeyword] = useState([]);
  const [jobLevelOptions, setJobLevelOptions] = useState([]);
  const [selectedStates, setSelectedStates] = useState([]);
  const [selectedCities, setSelectedCities] = useState([]);
  const [selectedGeo, setSelectedGeo] = useState([]);
  const [selectedJobFunction, setSelectedJobFunction] = useState([]);
  const [selectedEmployeeSize, setSelectedEmployeeSize] = useState([]);
  const [selectedIndustry, setSelectedIndustry] = useState([]);
  const [selectedSubIndustry, setSelectedSubIndustry] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [selectedSicCode, setSelectedSicCode] = useState([]);
  const [selectedNaicsCode, setSelectedNaicsCode] = useState([]);
  const [selectedRevenue, setSelectedRevenue] = useState([]); 
  const [selectedDateRange, setSelectedDateRange] = useState({ from: '', to: '' });
  const [selectedSKU, setSelectedSKU] = useState([]);
  const [selectedClient, setSelectedClient] = useState([]);
  const [resetFilters, setResetFilters] = useState(false);
  const [exporting, setExporting] = useState(false);
  const [error, setError] = useState(null); 
  const [isSubmitting, setIsSubmitting] = useState(false);  
  const [shouldSubmitFilters, setShouldSubmitFilters] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [cpcValue, setCpcValue] = useState(0);


  const [ setFile] = useState(null);
  // const { file: suppressionFile, handleFileChange: handleSuppressionFileChange, applySuppression } = useUploadSuppression();
  const [suppressionFile, setSuppressionFile] = useState(null);
  const { file, handleFileChange, handleApplySuppression, applied, applySuppression, suppressionData } = useUploadSuppression(filteredData, setFilteredData);

  const { talFile, handleTALFileChange, talData, applyTAL, setTalFile } = useUploadTAL(filteredData, setFilteredData);

  const { file: md5File, handleFileChange: handleMD5FileChange, applyMD5Suppression, md5Data } = useUploadMD5Suppression(filteredData, setFilteredData);

  // const { file: talFile, handleFileChange: handleTALFileChange, applyTAL } = useUploadTAL();

  const [currentUserEmail, setCurrentUserEmail] = useState(''); // State to store the logged-in user's email
  const [isLoggedIn, setIsLoggedIn] = useState(false); // new state to track login status
  const [username, setUsername] = useState(''); // new state to store username
  const [password, setPassword] = useState(''); // new state to store password
  const [loginError, setLoginError] = useState('');
  const [userRole, setUserRole] = useState('');

  const [totalDataCount, setTotalDataCount] = useState(0);
  const [count, setCount] = useState(0);
  const [previousCount, setPreviousCount] = useState(0);
  const [exportDisabled, setExportDisabled] = useState(false); // new state to track export button disable
  const [exportMessage, setExportMessage] = useState(''); // new state to track export message



useEffect(() => {
  const handleBeforeUnload = (event) => {
    const message = 'Do you really want to refresh? NOTE: Refreshing the app again will lead to loading of data again which might take few minutes. Consider resetting the filters.';
    (event || window.event).returnValue = message;
    return message;
  };

  window.addEventListener('beforeunload', handleBeforeUnload);

  return () => {
    window.removeEventListener('beforeunload', handleBeforeUnload);
  };
}, []);


  const filterData = useCallback((data) => {
    let filteredData = data;

    if (selectedKeyword.length > 0) {
      filteredData = filteredData.filter((item) => {
        return selectedKeyword.some((option) => item.OriginalJobTitle !== null && item.OriginalJobTitle.includes(option.value));
      });
    }

    if (jobLevelOptions.length > 0) {
      filteredData = filteredData.filter((item) => {
        return jobLevelOptions.some((option) => item.JobLevel !== null && item.JobLevel.includes(option.value));
      });
    }

    if (selectedJobFunction.length > 0) {
      filteredData = filteredData.filter((item) => {
        return selectedJobFunction.some((option) => item.JobFunction !== null && item.JobFunction.includes(option.value));
      });
    }

    if (selectedGeo.length > 0) {
      filteredData = filteredData.filter((item) => {
        return selectedGeo.some((option) => item.Country !== null && item.Country.includes(option.value));
      });
    }

    if (selectedStates.length > 0) {
      filteredData = filteredData.filter((item) => {
        return selectedStates.some((option) => item.State !== null && item.State.includes(option.value));
      });
    }

    if (selectedCities.length > 0) {
      filteredData = filteredData.filter((item) => {
        return selectedCities.some((option) => item.City !== null && item.City.includes(option.value));
      });
    }

    if (selectedIndustry.length > 0) {
      filteredData = filteredData.filter((item) => {
        return selectedIndustry.some((option) => item.OriginalIndustry !== null && item.OriginalIndustry.includes(option.value));
      });
    }

    if (selectedSubIndustry.length > 0) {
      filteredData = filteredData.filter((item) => {
        return selectedSubIndustry.some((option) => item.SubIndustry !== null && item.SubIndustry.includes(option.value));
      });
    }

    if (selectedSicCode.length > 0) {
      filteredData = filteredData.filter((item) => {
        return selectedSicCode.some((option) => item.SIC !== null && item.SIC.includes(option.value));
      });
    }

    if (selectedNaicsCode.length > 0) {
      filteredData = filteredData.filter((item) => {
        return selectedNaicsCode.some((option) => item.NAICS !== null && item.NAICS.includes(option.value));
      });
    }

    if (selectedDateRange.length > 0) {
      filteredData = selectedDateRange;
    }

    if (selectedEmployeeSize.length > 0) {
      filteredData = selectedEmployeeSize.reduce((acc, curr) => {
        const [minValue, maxValue] = curr.value.replace(/,/g, '').split('-').map(Number);
        return acc.concat(filteredData.filter((item) => {
          const empSize = parseInt(item.EmployeeSize.replace(/,/g, ''));
          return empSize >= minValue && empSize <= maxValue;
        }));
      }, []);
    }

    if (selectedRevenue.length > 0) {
      filteredData = selectedRevenue.flatMap((curr) => {
        const [minValue, maxValue] = curr.value.replace(/,/g, '').split('-').map(Number);
        return data.filter((item) => {
          if (item.Revenue !== null && item.Revenue !== undefined) {
            const revenueSizeString = item.Revenue;
            const revenueSize = parseFloat(revenueSizeString.replace('$', '').replace(' Million', 'e6').replace(' Billion', 'e9'));
            return revenueSize >= minValue && revenueSize <= maxValue;
          } else {
            return false; // or some other logic to handle this case
          }
        });
      });
    }

    if (selectedSKU.length > 0) {
      filteredData = filteredData.filter((item) => {
        return selectedSKU.some((option) => item.SKUCode !== null && item.SKUCode.includes(option.value));
      });
    }

    if (selectedClient.length > 0) {
      filteredData = filteredData.filter((item) => {
        return selectedClient.some((option) => item.EndClient !== null && item.EndClient.includes(option.value));
      });
    }

    if (md5File) {
      filteredData = applyMD5Suppression(filteredData); // Apply MD5 suppression
    }


    if (suppressionFile) {
      filteredData = applySuppression(filteredData);
    }

    if (talFile) {
      filteredData = applyTAL(filteredData);
    }

    if (talFile) {
      console.log('filteredData before applyTAL:', filteredData);
      if (talData.CompanyName.length > 0 && talData.Domain.length > 0) {
        filteredData = applyTAL(filteredData);
      } else {
        console.log('talData is empty, skipping filter');
      }
      console.log('compressedData after applyTAL:', filteredData);
    }

return filteredData;
}, [data, selectedSKU, selectedKeyword, jobLevelOptions, selectedStates, selectedCities, selectedGeo, selectedJobFunction, selectedEmployeeSize, selectedIndustry, selectedSubIndustry, selectedSicCode, selectedNaicsCode, selectedRevenue, selectedDateRange, suppressionFile, talFile, applySuppression, applyTAL, suppressionData, md5File, applyMD5Suppression]);


    useEffect(() => {
      const fetchTotalCount = async () => {
        try {
          // const response = await axios.get('https://f063-115-160-212-66.ngrok-free.app/data');
          const response = await axios.get('https://sqldatabase.ngrok.app/data');
          console.log('Response:', response);
          const totalRecords = response.data.totalRecords;
          console.log('Total records:', totalRecords);
          setTotalDataCount(totalRecords);
        } catch (error) {
          console.error('Error fetching total records:', error);
        }
      };
    
      fetchTotalCount();
    }, []);


    
    // App.js    
    useEffect(() => {
      if (shouldSubmitFilters) {
        setIsLoading(true); // Set isLoading to true here
        const fetchFilteredData = async () => {
          const filters = {
            DateRange: selectedDateRange,
            SKUCode: selectedSKU.map((skucode) => skucode.value),
            EndClient: selectedClient.map((endclient) => endclient.value),
            Keywords: selectedKeyword.map((keyword) => keyword.value),
            JobFunction: selectedJobFunction.map((jobFunctions) => jobFunctions.value),
            JobLevel: jobLevelOptions.map((option) => option.value),
            Industry: selectedIndustry.map((industry) => industry.value),
            SubIndustry: selectedSubIndustry.map((subIndustry) => subIndustry.value),
            Geo: selectedGeo.map((geoNames) => geoNames.value),
            StateNames: selectedStates.map((stateNames) => stateNames.value),
            CityNames: selectedCities.map((cityNames) => cityNames.value),
            EmployeeSize: selectedEmployeeSize.map((employeeSizeOptions) => employeeSizeOptions.value),
            SIC: selectedSicCode.map((sic) => sic.value),
            NAICS: selectedNaicsCode.map((naicsCode) => naicsCode.value), 
            Revenue: selectedRevenue.map((revenueOptions) => revenueOptions.value), 
            SuppressionData: suppressionData,
            TALData: talData,
            MD5Data: md5Data,
            cpc: cpcValue
          };
        
          try {
            const response = await axios.post('https://sqldatabase.ngrok.app/filteredData', filters);
            // const response = await axios.post('http://localhost:3002/filteredData', filters);
            const decompressedData = response.data.map((row) => {
              Object.keys(row).forEach((key) => {
                row[key] = LZString.decompress(row[key]);
              });
              return row;
            });
            setFilteredData(decompressedData);
            setCount(decompressedData.length);
          } catch (error) {
            console.error('Error fetching filtered data:', error);
          } finally {
            setIsLoading(false); // Set isLoading to false here
          }
        };
        
        fetchFilteredData();
        setShouldSubmitFilters(false);
      }
    }, [jobLevelOptions, selectedSKU, selectedClient , selectedIndustry, selectedSubIndustry, selectedJobFunction, selectedKeyword, selectedGeo, selectedStates, selectedCities, selectedSicCode, selectedNaicsCode, selectedRevenue, selectedEmployeeSize , suppressionData, talData, md5Data ,shouldSubmitFilters]); 

  


  useEffect(() => {
    if (shouldSubmitFilters) {
      const filteredData = filterData(data);
      setFilteredData(filteredData);
      setCount(filteredData.length);
      setShouldSubmitFilters(false);
    }
  }, [data, selectedSKU , selectedClient, selectedKeyword, selectedStates, selectedCities, selectedGeo, selectedJobFunction, selectedEmployeeSize, selectedIndustry, selectedSubIndustry, selectedSicCode, selectedNaicsCode, selectedRevenue, selectedDateRange, suppressionFile, talFile, md5Data ,shouldSubmitFilters]);



useEffect(() => {
  if (!userRole) return;     // wait until login has set your role

  const highLimitUsers = ['admin', 'Arshad.b'];
  const userLimit = highLimitUsers.includes(userRole) ? 100000 : 50000;

  console.log(`Role: ${userRole} → Limit: ${userLimit} | Count: ${count}`);

  if (count > userLimit) {
    setExportDisabled(true);
    setExportMessage(
      `❌ You can only export up to ${userLimit.toLocaleString()} records.`
    );
  } else {
    setExportDisabled(false);
    setExportMessage('');
  }
}, [count, userRole]);

  const handleDateRangeChange = (from, to) => {
    setSelectedDateRange({ from, to });
  };

  const handleSKUChange = (options) => {
    setSelectedSKU(options);
  };

  const handleClientChange = (options) => {
    setSelectedClient(options);
  };

  const handleKeywordChange = (options) => {
    setSelectedKeyword(options);
  };

  const handleJobLevelChange = (options) => {
    setJobLevelOptions(options);
  };

  const handleJobFunctionChange = (options) => {
    setSelectedJobFunction(options);
  }; 

  const handleGeoChange = (options) => {
    setSelectedGeo(options);
  };  

  const handleStateChange = (options) => {
    setSelectedStates(options);
  };

  const handleCityChange = (options) => {
    setSelectedCities(options);
  };

  const handleEmployeeSizeChange = (options) => {
    setSelectedEmployeeSize(options);
  };

  const handleIndustryChange = (options) => {
    setSelectedIndustry(options);
  };

  const handleSubIndustryChange = (options) => {
    setSelectedSubIndustry(options);
  };

  const handleSicCodeChange = (options) => {
    setSelectedSicCode(options);
  };

  const handleNaicsCodeChange = (options) => {
    setSelectedNaicsCode(options);
  };

  const handleRevenueChange = (options) => {
    setSelectedRevenue(options);
  };

  const handleSubmit = async () => {
    setIsLoading(true);
    setShouldSubmitFilters(true);
  };




  const handleExportToExcel = () => {
    if (!exportDisabled) {
      const worksheet = utils.json_to_sheet(filteredData);
      const workbook = utils.book_new();
      utils.book_append_sheet(workbook, worksheet, 'Data');
      const csvBuffer = write(workbook, { bookType: 'csv', type: 'buffer' });
      const dataURI = `data:text/csv;base64,${Buffer.from(csvBuffer).toString('base64')}`;
      const link = document.createElement('a');
      link.href = dataURI;
      link.download = 'Export_data.csv';
      link.click();
    }
  };




  const handleResetFiltersClick = () => {
    setResetFilters(true);
  };

  const handleReset = () => {
    setSelectedDateRange([]);
    setSelectedSKU([]);
    setSelectedClient([]);
    setSelectedKeyword([]);
    setJobLevelOptions([]);
    setSelectedStates([]);
    setSelectedCities([]);
    setSelectedGeo([]);
    setSelectedJobFunction([]);
    setSelectedEmployeeSize([]);
    setSelectedIndustry([]);
    setSelectedSubIndustry([]);
    setSelectedSicCode([]);
    setSelectedNaicsCode([]);
    setSelectedRevenue([]);
    setSelectedDateRange([]);
    setResetFilters(false); // Reset the resetFilters state variable
    setCount(0); // Reset the count to 0
    setSuppressionFile(null); // Reset the suppressionFile state variable
    setTalFile(null); // Reset the talFile state variable
  
    
    // Create a new file input element
    const newTalFileInput = document.createElement('input');
    newTalFileInput.type = 'file';
    newTalFileInput.id = 'talFileInput';
    newTalFileInput.name = 'talFileInput';
  
    // Get the existing file input element
    const talFileInput = document.getElementById('talFileInput');
  
    // Check if the element exists before trying to access its parentNode property
    if (talFileInput) {
      talFileInput.parentNode.replaceChild(newTalFileInput, talFileInput);
    } else {
      console.log("Element with ID 'talFileInput' not found");
    }
  };


  // const downloadTemplate = (templateType) => {
  //   const templateName = templateType === 'suppression' ? 'Suppression Template.xlsm' : 'TAL Template.xlsm';
  //   const link = document.createElement('a');
  //   link.href = `${process.env.PUBLIC_URL}/${templateName}`;
  //   link.download = templateName;
  //   link.click();
  // };


  const downloadTemplate = (templateType) => {
    let templateName;
  
    // Determine the template name based on the templateType
    if (templateType === 'suppression') {
      templateName = 'Suppression Template.xlsm';
    } else if (templateType === 'tal') {
      templateName = 'TAL Template.xlsm';
    } else if (templateType === 'md5') { // New condition for MD5 suppression template
      templateName = 'MD5 Suppression Template.xlsx';
    } else {
      console.error('Invalid template type');
      return; // Exit the function if the template type is invalid
    }
  
    // Create a link element to download the template
    const link = document.createElement('a');
    link.href = `${process.env.PUBLIC_URL}/${templateName}`;
    link.download = templateName;
    link.click();
  };


  
  const handleLogin = (username, password) => {
    if (username === 'admin' && password === 'DemandMediaSaNaYa@2025') {
      setIsLoggedIn(true);
      setUserRole('admin');
      setCurrentUserEmail('nadeem.m@demandmediabpm.com');

    } else if (username === 'Pratibha.l' && password === 'a6UsO2F7Xr5x32YX') {
      setIsLoggedIn(true);
      setUserRole('Pratibha.l');
      setCurrentUserEmail('pratibha.l@demandmediabpm.com');
    
    } else if (username === 'Pravin.w' && password === 'Pravin@5x32YX') {
      setIsLoggedIn(true);
      setUserRole('Pravin.w');
      setCurrentUserEmail('pravin.w@demandmediabpm.com');  
      
    } else if (username === 'Venkat.s' && password === 'a6UsO2F7Xr5x32YX') {
      setIsLoggedIn(true);
      setUserRole('Venkat.s');
      setCurrentUserEmail('venkat.s@demandmediabpm.com');

    } else if (username === 'Majid.s' && password === 'AjUHt2O9Tv75nM2v') {
      setIsLoggedIn(true);
      setUserRole('Majid.s');
      setCurrentUserEmail('majid.s@demandmediabpm.com');

    }  else if (username === 'Arshad.b' && password === 'XB9B7xxZa0XJ1MyE') {
      setIsLoggedIn(true);
      setUserRole('Arshad.b');
      setCurrentUserEmail('arshad.b@demandmediabpm.com');

    }  else if (username === 'Subochandrabose.k' && password === 'Mlr614ViypbI4i5z') {
      setIsLoggedIn(true);
      setUserRole('Subochandrabose.k');
      setCurrentUserEmail('subochandrabose.k@demandmediabpm.com');

    } else if (username === 'Venkateshwarlu.d' && password === 'x5A815w9mkLDZoJ7') {
      setIsLoggedIn(true);
      setUserRole('Venkateshwarlu.d');
      setCurrentUserEmail('venkateshwarlu.d@demandmediabpm.com');

    }  else if (username === 'Harry.p' && password === 'ct8wgU4wLT8P1AnE') {
      setIsLoggedIn(true);
      setUserRole('Harry.p');

    }  else if (username === 'Sachin.t' && password === '1wlAXo85jkTWzVrC') {
      setIsLoggedIn(true);
      setUserRole('Sachin.t');

    }  else if (username === 'Shreeram.k' && password === 'MYLe38v0Th3cI7FO') {
      setIsLoggedIn(true);
      setUserRole('Shreeram.k');

    }  else if (username === 'Basavraj.m' && password === '5jbbCZ15Mi2jAW23') {
      setIsLoggedIn(true);
      setUserRole('Basavraj.m');

    }  else {
      setLoginError('Incorrect ID or Password. Please contact admin');
    }
  };



  const handleExportToEmail = async () => {
    if (!exportDisabled && currentUserEmail) {
        try {
            // Convert filtered data to CSV format
            const worksheet = utils.json_to_sheet(filteredData, {
              cellDates: true, // This option ensures that date cells are treated as dates
            });
            const workbook = utils.book_new();
            utils.book_append_sheet(workbook, worksheet, 'Filtered Data');

            // Write the workbook to a CSV string
            const csvBuffer = write(workbook, { bookType: 'csv', type: 'buffer' });

            // Create a FormData object to send the file
            const formData = new FormData();
            const file = new Blob([csvBuffer], { type: 'text/csv' });
            formData.append('file', file, 'FilteredData.csv'); // Ensure the key matches
            formData.append('email', currentUserEmail); // Ensure email is included

            // Include the count in the subject
            const subject = `Exported Data - Count: ${count}`; // Assuming 'count' is the count of filteredData
            formData.append('subject', subject); // Add subject to the form data

            // Send the email with the CSV file
            const response = await axios.post('https://sqldatabase.ngrok.app/sendExportedData', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data' // Important for file uploads
                }
            });

            alert(response.data.message);
        } catch (error) {
            console.error('Error sending email:', error);
            alert('Failed to send email. Please try again.');
        }
    } else {
        alert('Export is disabled or user is not logged in.');
    }
};


const handleLogout = () => {
  handleReset();        
  setIsLoggedIn(false);
  setCount(0);          
};




  return (
    <div>
      {isLoggedIn ? (
        <div>
          {isLoading ? (
              <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(255, 255, 255, 0.7)', zIndex: 1000, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <Puff color="#00BFFF" height={100} width={100} />
            </div>
          ) : (
            <div>
              {/* <Navbar title="CM360" logout={<Logout handleLogout={handleLogout} />} /> */}
              <Navbar title="CM360" logout={<Logout handleLogout={handleLogout} />} username={username} />
              <div className='top-container'>
                <div className='columns-container' style={{
                  display: 'grid',
                  gridTemplateColumns: '1fr 1fr',
                  justifyContent: 'center',
                  alignItems: 'center',
                  textAlign: 'center',
                  maxWidth: 800, /* add max-width to match the width of other filters */
                }}>
                  <div className='column total-records'>
                    <p>
                      <strong style={{ fontSize: 18, marginRight: 10, color: '#19A79C' }}>TOTAL RECORDS : </strong>
                      <span style={{ fontSize: 24, fontWeight: 500, color: '#19A79C' }}>{totalDataCount}</span>
                    </p>
                  </div>
                  <div className='column filtered-records'>
                    <p>
                      <strong style={{ fontSize: 18, marginRight: 10, color: '#19A79C' }}>FILTERED RECORDS :</strong>
                      <CountUp
                        key={count} // re-render with new value
                        start={previousCount} // set starting value to previous count
                        end={count}
                        duration={2}
                        separator=","
                        decimals={0}
                        prefix=""
                        suffix=""
                        onEnd={() => {
                          setPreviousCount(count); // update previous count
                          console.log("Finished counting");
                        }}
                        style={{ fontSize: 24, fontWeight: 500, color: count > 100000 ? 'red' : '#19A79C' }}
                      />
                    </p>
                  </div>
                </div>
              </div>
  
              <div className='container'>
  
                <div style={{ marginBottom: 20 }}>
                  <DateRangeFilter 
                    data={data} 
                    handleSelectChange={handleDateRangeChange} 
                    />
                </div>

                <div className="cpc-slider-container">
                <label htmlFor="cpc-slider" className="cpc-label">
                  CPC (Contacts Per Company): <span className="cpc-value">{cpcValue}</span>
                </label>
                <input
                  id="cpc-sli der"
                  type="range"
                  min="0"
                  max="30"
                  value={cpcValue}
                  onChange={(e) => setCpcValue(Number(e.target.value))}
                  className="cpc-slider"
                />
              </div>


                                
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 20 }}>
                  <div style={{ flex: 1, marginRight: 10 }}>
                    <label style={{color:'white'}}><b>SKU Code :</b></label>
                    <SKU 
                      data={data} 
                      selectedSKU={selectedSKU} 
                      handleSelectChange={handleSKUChange} 
                    />
                  </div>
                                
                  <div style={{ flex: 1 }}>
                    <label style={{color:'white'}}><b>End Client :</b></label>
                    <Client 
                      data={data} 
                      selectedClient={selectedClient} 
                      handleSelectChange={handleClientChange} 
                    />
                  </div>
                </div>
                                
                <div style={{ marginBottom: 20 }}>
                  <label style={{color:'white'}}><b>Keywords :</b></label>
                  <Keyword 
                    data={data} 
                    selectedKeyword={selectedKeyword} 
                    handleSelectChange={handleKeywordChange} 
                  />
                </div>
                
                <div style={{ marginBottom: 20 }}>
                  <label style={{color:'white'}}><b>Job Function :</b></label>
                  <JobFunction 
                    data={data} 
                    selectedJobFunction={selectedJobFunction} 
                    handleSelectChange={handleJobFunctionChange} 
                  />
                </div>
                <div style={{ marginBottom: 20 }}>
                  <label style={{color:'white'}}><b>Job Level :</b></label>
                  <JobLevel 
                    data={data} 
                    jobLevelOptions={jobLevelOptions} 
                    handleSelectChange={handleJobLevelChange} 
                  />
                </div>
                <div style={{ marginBottom: 20 }}>
                  <label style={{color:'white'}}><b>Industry :</b></label>
                  <Industry 
                    data={data} 
                    selectedIndustry={selectedIndustry} 
                    handleSelectChange={handleIndustryChange} 
                  />
                </div>
                <div style={{ marginBottom: 20 }}>
                  <label style={{color:'white'}}><b>SubIndustry :</b></label>
                  <SubIndustry 
                    data={data} 
                    selectedSubIndustry={selectedSubIndustry} 
                    handleSelectChange={handleSubIndustryChange} 
                  />
                </div>
                <div style={{ marginBottom: 20 }}>
                  <label style={{color:'white'}}><b>Country :</b></label>
                  <Geo 
                    data={data} 
                    selectedGeo={selectedGeo} 
                    handleSelectChange={handleGeoChange} 
                  />
                </div>
                <div style={{ marginBottom: 20 }}>
                  <label style={{color:'white'}}><b>States :</b></label>
                  <StateNames 
                    data={data} 
                    selectedStates={selectedStates} 
                    handleSelectChange={handleStateChange} 
                  />
                </div>
                <div style={{ marginBottom: 20 }}>
                  <label style={{color:'white'}}><b>City :</b></label>
                  <CityNames 
                    data={data} 
                    selectedCities={selectedCities} 
                    handleSelectChange={handleCityChange} 
                  />
                </div>
                <div style={{ marginBottom: 20 }}>
                  <label style={{color:'white'}}><b>Employee Size :</b></label>
                  <EmployeeSize 
                    data={data} 
                    selectedEmployeeSize={selectedEmployeeSize } 
                    handleSelectChange={handleEmployeeSizeChange} 
                  />
                </div>
                <div style={{ marginBottom: 20 }}>
                  <label style={{color:'white'}}><b>SIC :</b></label>
                  <SIC
                    data={data} 
                    selectedSicCode={selectedSicCode} 
                    handleSelectChange={handleSicCodeChange} 
                  />
                </div>
                <div style={{ marginBottom: 20 }}>
                  <label style={{color:'white'}}><b>NAICS :</b></label>
                  <NAICS
                    data={data} 
                    selectedNaicsCode={selectedNaicsCode} 
                    handleSelectChange={handleNaicsCodeChange} 
                  />
                </div>   
                <div style={{ marginBottom: 40 }}>
                  <label style={{color:'white'}}><b>Revenue :</b></label>
                  <Revenue
                    data={data} 
                    selectedRevenue={selectedRevenue} 
                    handleSelectChange={handleRevenueChange} 
                  />
                </div>    

            <div style={{ display: 'flex', justifyContent: 'space-between', margin: 'auto', maxWidth: '90%' }}>

                  <div style={{ backgroundColor: '#FAF9F6', padding: 25, width: '50%', marginRight: 20, borderRadius: '20px' }}>
                    <label style={{ color: '#1EAA9D', fontSize: 18 }}><b>Upload MD5 Suppression:</b></label>
                    <div style={{ marginTop: 10 }}>
                      <input type="file" onChange={(e) => handleMD5FileChange(e.target.files[0])} />
                      {/* {suppressionFile && (
                        <div>
                          <p>File uploaded: {suppressionFile.name}</p>
                          <button style={{ padding: '5px 10px', fontSize: 12 }} onClick={() => setSuppressionFile(null)}><b>Remove</b></button>
                        </div>
                      )} */}
                    </div>
                    <div style={{ marginTop: 10 }}>
                      <button style={{ padding: '5px 10px', fontSize: 12 }} onClick={() => downloadTemplate('md5')}><b>Download MD5 Suppression Template</b></button>
                    </div>
                  </div>  


                  <div style={{ backgroundColor: '#FAF9F6', padding: 25, width: '50%', marginRight: 20, borderRadius: '20px' }}>
                    <label style={{ color: '#1EAA9D', fontSize: 18 }}><b>Upload Suppression:</b></label>
                    <div style={{ marginTop: 10 }}>
                      <input type="file" onChange={(e) => handleFileChange(e.target.files[0])} />
                      {/* {suppressionFile && (
                        <div>
                          <p>File uploaded: {suppressionFile.name}</p>
                          <button style={{ padding: '5px 10px', fontSize: 12 }} onClick={() => setSuppressionFile(null)}><b>Remove</b></button>
                        </div>
                      )} */}
                    </div>
                    <div style={{ marginTop: 10 }}>
                      <button style={{ padding: '5px 10px', fontSize: 12 }} onClick={() => downloadTemplate('suppression')}><b>Download Suppression Template</b></button>
                    </div>
                  </div>

                      
                  <div style={{ backgroundColor: '#FAF9F6', padding: 25, width: '50%', borderRadius: '20px'}}>
                    <label style={{ color: '#1EAA9D', fontSize: 18 }}><b>Upload TAL:</b></label>
                    <div style={{ marginTop: 10 }}>
                      <input type="file" onChange={(e) => handleTALFileChange(e.target.files[0])} />
                      {/* {talFile && (
                        <div>
                          <p>File uploaded: {talFile.name}</p>
                          <button style={{ padding: '5px 10px', fontSize: 12 }} onClick={() => setTalFile(null)}><b>Remove</b></button>
                        </div>
                      )} */}
                    </div>
                    <div style={{ marginTop: 10 }}>
                      <button style={{ padding: '5px 10px', fontSize: 12 }} onClick={() => downloadTemplate('tal')}><b>Download TAL Template</b></button>
                    </div>
                  </div>
                </div>
  
                <div style={{textAlign: 'center', margin: '40px'}}>
                  <button style={{ marginRight: 10 }} onClick={() => { handleReset([]); }}>
                    <b>Reset Filters</b>
                  </button>
                  <button style={{ marginRight: 10 }} onClick={handleSubmit} disabled={isSubmitting}>
                    <b>Submit Filters</b>
                  </button>
                  {exportDisabled ? (
                      <p style={{ color: 'red' }}>{exportMessage}</p>
                    ) : (
                      userRole === 'Basavraj.m' ||
                      userRole === 'Shreeram.k' ||
                      userRole === 'Sachin.t' ||
                      userRole === 'Harry.p' ? null : (
                        <button onClick={handleExportToEmail}>
                          <b>Export Data</b>
                        </button>
                      )
                    )}
                </div>
              </div>
            </div>
          )}
        </div>
      ) : (
        <Login handleLogin={handleLogin} loginError={loginError} />
      )}
    </div>
  );
  
};

export default App;